import DocumentInput from "@app/components/document-input/DocumentInput";
import {
    signApprovedFile,
    signIssuedFile,
    signIncomingFile,
    signListFiles,
} from "@app/pages/kySo/helperKyToken";
import { BaseGatewayImage } from "@app/utils/apiUrl";
import React, { useState } from "react";
import { Form } from "react-bootstrap";

import { toast } from "react-toastify";

const DigitalSign = () => {
    const [fileUrl, setFileUrl] = useState("");
    const [result, setResult] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const getAbsoluteFileUrl = (filePath) => {
        if (!filePath) return "";
        if (/^https?:\/\//i.test(filePath)) return filePath;
        return `${BaseGatewayImage}${filePath}`;
    };

    const getFileName = (file) => {
        const filePath = file?.filePath || file?.url || file?.URL || file || "";
        return file?.fileName || file?.name || filePath.split("/").pop() || "document";
    };

    const handleSignApproved = async () => {
        try {
            const res = await signApprovedFile(fileUrl);
            setResult(res);
            toast.success("Ký phê duyệt thành công");
        } catch (err) {
            console.error(err);
            toast.error(err?.Message || err?.message || "Ký số thất bại");
        }
    };

    const handleSignIssued = async () => {
        try {
            const res = await signIssuedFile(fileUrl, "79", "");
            setResult(res);
            toast.success("Ký phát hành thành công");
        } catch (err) {
            console.error(err);
            toast.error(err?.Message || err?.message || "Ký số thất bại");
        }
    };

    const handleSignIncome = async () => {
        try {
            const res = await signIncomingFile(fileUrl, [
                { Key: "LoaiVanBan", Value: "CongVanDen" },
            ]);
            setResult(res);
            toast.success("Ký công văn đến thành công");
        } catch (err) {
            console.error(err);
            toast.error(err?.Message || err?.message || "Ký số thất bại");
        }
    };

    const handleSignManyFiles = async () => {
        try {
            const files = uploadedFiles.length > 0
                ? uploadedFiles.map((file, index) => {
                    const filePath = file.filePath || file.url || file.URL || file;
                    return {
                        FileID: String(file.id || file.fileId || index + 1),
                        FileName: getFileName(file) + ".pdf",
                        URL: getAbsoluteFileUrl(filePath),
                    };
                })
                : [
                    {
                        FileID: "1",
                        FileName: fileUrl.split("/").pop() || "test1.pdf",
                        URL: fileUrl,
                    },
                ];

            const res = await signListFiles(files);
            setResult(res);
            toast.success("Ký danh sách file thành công");
        } catch (err) {
            console.error(err);
            toast.error(err?.Message || err?.message || "Ký số thất bại");
        }
    };

    return (
        <div className="container mt-4">
            <h3>Ký số VGCA + OpenIddict SSO</h3>

            <input
                className="form-control"
                placeholder="Nhập URL file PDF cần ký"
                value={fileUrl}
                onChange={(e) => setFileUrl(e.target.value)}
            />

            <div className="mt-3">
                <button className="btn btn-primary mr-2" onClick={handleSignApproved}>
                    Lãnh đạo ký phê duyệt
                </button>

                <button className="btn btn-success mr-2" onClick={handleSignIssued}>
                    Văn thư ký phát hành
                </button>

                <button className="btn btn-warning mr-2" onClick={handleSignIncome}>
                    Ký công văn đến
                </button>

                <button className="btn btn-info" onClick={handleSignManyFiles}>
                    Ký danh sách file
                </button>
            </div>

            <Form.Group>
                <Form.Label className="font-weight-bold">Chọn nhiều files</Form.Label>
                <DocumentInput
                    multiple={true}
                    value={uploadedFiles}
                    onFilesChange={(files) => setUploadedFiles(files)}
                    labelTitle="Chọn nhiều files"
                />
            </Form.Group>


            {result && (
                <pre className="mt-3 bg-light p-3">
                    {JSON.stringify(result, null, 2)}
                </pre>
            )}
        </div>
    );
};

export default DigitalSign;
